import React from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as IconNoticeClose } from "./icon/icon_notice_close.svg";
import { ReactComponent as IconNoticeDivide } from "./icon/icon_notice_divide.svg";
import { ReactComponent as IconNoticeFintech } from "./icon/icon_notice_fintech.svg";
import { ReactComponent as IconNoticeGroup } from "./icon/icon_notice_group.svg";
import { useDisclaimer } from "@/context/DisclaimerContext";
import styles from "./index.module.scss";

const SuspensionNotice = () => {
  const { isOpen, closeDisclaimer } = useDisclaimer();
  const currentPath = useLocation();
  const isReceivedPage = currentPath.pathname.includes("/received");

  if (!isOpen || isReceivedPage) return null;

  return (
    <div className={styles.notice}>
      <div className={styles.layout}>
        <IconNoticeClose className={styles.close} onClick={closeDisclaimer} />
        <div className={styles.noticeBanner}>公告</div>
        <div className={styles.noticeTitle}>貸款須知與免責聲明</div>
        <div className={styles.noticeContent}>
          請注意以下貸款須知與免責聲明：
          <br />
          <br />
          1. 信用貸款利率計算： <br />
          信用貸款利率是指信用貸款借款人所需負擔的利息支出與本金的比率。通常以年利率為計算單位。依據目前民法規定，信用貸款的年利率最高上限為
          16%。詳細的年利率還是要依據【歐悅金融科技】提供之約定及申請書計算方式為主。【歐悅金融科技】提供的實際年利率介於最低
          1.66% 至最高 16%
          之間。實際貸款條件以歐悅金融科技提供的產品為準，每位客戶的實際年利率會因個別貸款產品和授信條件而有所不同。總費用年百分率
          (APR)
          是根據貸款金額、利率、期間以及其他費用所加總計算出的年百分率，作為貸款的實際成本。
          <br />
          <br />
          2. 核貸條件： <br />
          【歐悅金融科技】保留核貸額度、適用利率、年限期數以及核貸與否的權利。詳細的約定應以歐悅金融科技提供的貸款申請書和約定書為準。
          <br />
          <br />
          3. 每月應繳金額計算參考以下為一個參考案例： <br />
          假設貸款金額為 50 萬，貸款期間 7 年，貸款利率為 1.66% 至
          16.00%，且免開辦費。根據此資訊，利息相關費用可能介於 5,983.85 元至
          11,146.17
          元之間。請注意：此為範例僅供參考，實際貸款條件會因客戶本身情況而有所不同。
          <br />
          <br />
          4. 還款年限： <br />
          【歐悅利可貸】 還款年限：1~3 年【騎夢駕享貸】 還款年限：1~7
          年【樂享新居貸】 還款年限：1~10 年
          若有任何疑問或需要進一步了解，歡迎與我們聯繫。
        </div>

        <div className={styles.imgGroup}>
          <IconNoticeGroup />
          <IconNoticeDivide />
          <IconNoticeFintech />
        </div>
      </div>
    </div>
  );
};

export default SuspensionNotice;
